export const ORDER_INFORMATION_KEY = 'order-information';
